// extracted by mini-css-extract-plugin
module.exports =  {"default":"_32bbee5fda--default--dhFc5","light":"_32bbee5fda--light--cr1uo","outline":"_32bbee5fda--outline--gZT__"};